define('brandspage_collection.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('brandspage_collection', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-type=\"backbone.collection.view.rows\"></div>";
},"useData":true}, 'extensions/PSeComm/JeskeBrandsPage/1.0.1/', 'extensions/PSeComm/JeskeBrandsPage/1.0.1/', Handlebars);
});